// iter64 — Text search utilities: normalize (strip diacritics, lowercase) + debounce hook.
import { useEffect, useState } from "react";

/**
 * Removes accents (á→a, ñ→n) and lowercases the string for case+accent-insensitive
 * matching. Empty/nullish input returns "".
 */
export function normalizeText(s) {
  if (s === null || s === undefined) return "";
  return String(s)
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim();
}

/**
 * Returns true if `haystack` contains `needle` after normalization.
 */
export function containsNorm(haystack, needle) {
  if (!needle) return true;
  const nh = normalizeText(haystack);
  const nn = normalizeText(needle);
  return nh.includes(nn);
}

/**
 * useDebounce — returns the input value after it has been stable for `delay` ms.
 */
export function useDebounce(value, delay = 250) {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(t);
  }, [value, delay]);
  return debounced;
}

/**
 * Human-friendly labels for payment methods.
 */
export const PAYMENT_METHOD_LABELS = {
  yape: "Yape",
  plin: "Plin",
  transferencia: "Transferencia",
  mercado_pago: "Mercado Pago",
  mercadopago: "Mercado Pago",
  culqi: "Tarjeta (Culqi)",
  tarjeta: "Tarjeta",
  card: "Tarjeta",
  cash: "Efectivo",
  manual: "Manual",
  whatsapp: "WhatsApp manual",
};

export function paymentMethodLabel(method) {
  if (!method) return "—";
  const k = String(method).toLowerCase();
  return PAYMENT_METHOD_LABELS[k] || method;
}
